module.exports = __webpack_public_path__ + "img/xcg1.558f642d.jpg";